var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('qr-widget'),_c('router-view',{key:_vm.$route.fullPath}),_c('v-overlay',{attrs:{"value":_vm.pageLoader}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primaryMain"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }